export default "__VITE_ASSET__CQpa4Vml__"